import React from 'react';
import { useAuth } from  '../teacher/AuthContext'; // Path to your context
import { useNavigate } from 'react-router-dom';

const PendingApproval = () => {
  const auth = useAuth();
  const navigate = useNavigate();

  // Safety check to prevent the "Cannot destructure property" error
  if (!auth) {
    return <div className="flex justify-center mt-20">Loading...</div>;
  }

  const { currentUser, logout } = auth;

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="max-w-md w-full text-center space-y-6 p-8 bg-white shadow-lg rounded-xl">
        <div className="flex justify-center">
          <div className="bg-yellow-100 p-3 rounded-full">
            <svg className="h-10 w-10 text-yellow-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
        </div>
        
        <h2 className="text-2xl font-bold text-gray-900">Account Pending Approval</h2>
        
        <p className="text-gray-600">
          Hi <span className="font-semibold">{currentUser?.email}</span>, thanks for joining **Trianf**. 
          An administrator needs to approve your account before you can access the dashboard.
        </p>

        <div className="pt-4 border-t border-gray-100">
          <button
            onClick={handleLogout}
            className="text-sm font-medium text-blue-600 hover:text-blue-500 underline"
          >
            Log out and check back later
          </button>
        </div>
      </div>
    </div>
  );
};

export default PendingApproval;